import React from 'react';

import { PageTitle } from '../../../components';
import { Tickets } from '../..';



const TicketPage = () => {  
  return (   
    <> 

      {/* Page Title */}
      <PageTitle title={'Registration'} page={'Registration'} />
      
      {/* Ticket Section */}
      <Tickets />
      
    </>
  )
}

export default TicketPage;